import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "md_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        // small delay so it doesn't fight the hero animation
        const t = setTimeout(() => setVisible(true), 1200);
        return () => clearTimeout(t);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const updateConsent = (granted) => {
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: granted ? "granted" : "denied",
        ad_user_data: granted ? "granted" : "denied",
        ad_personalization: granted ? "granted" : "denied",
        analytics_storage: granted ? "granted" : "denied",
      });
    }
  };

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "accepted");
    } catch (e) {}
    updateConsent(true);
    // Notify analytics helper so it can lazy-load Meta Pixel
    try {
      window.dispatchEvent(new Event("md:consent-accepted"));
    } catch (e) {}
    setVisible(false);
  };

  const reject = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "rejected");
    } catch (e) {}
    updateConsent(false);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[9999]"
        >
          <div
            className="rounded-lg border border-white/10 bg-black/90 backdrop-blur-xl p-5 shadow-2xl"
            style={{ boxShadow: "0 20px 60px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,200,0,0.08)" }}
          >
            <div className="flex items-start gap-3 mb-3">
              <div
                className="mt-1 h-2 w-2 rounded-full"
                style={{ background: "#FFC800", boxShadow: "0 0 8px #FFC800" }}
              />
              <div>
                <h3
                  className="text-white text-sm font-semibold tracking-wide mb-1"
                  style={{ letterSpacing: "0.08em" }}
                >
                  COOKIE & PRIVACY
                </h3>
                <p className="text-white/70 text-xs leading-relaxed">
                  Usiamo cookie di analytics per capire come navighi il sito e migliorare la
                  tua esperienza. Puoi accettare o rifiutare — la scelta è tua.{" "}
                  <a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline hover:text-[#FFC800] transition-colors"
                  >
                    Privacy Policy
                  </a>
                </p>
              </div>
            </div>
            <div className="flex gap-2 mt-4">
              <button
                data-testid="cookie-reject-btn"
                onClick={reject}
                className="flex-1 text-xs font-medium tracking-wider px-4 py-2.5 rounded-full border border-white/20 text-white/80 hover:text-white hover:border-white/40 transition-all"
                style={{ letterSpacing: "0.08em" }}
              >
                RIFIUTA
              </button>
              <button
                data-testid="cookie-accept-btn"
                onClick={accept}
                className="flex-1 text-xs font-semibold tracking-wider px-4 py-2.5 rounded-full bg-[#FFC800] text-black hover:bg-[#ffdb4d] transition-all"
                style={{ letterSpacing: "0.08em" }}
              >
                ACCETTA TUTTO
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
